import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    searchtabs:{},
    tabPanel:{},
    adminLayoutWrapper: {
        minHeight: 'calc(100vh - 150px)',
        //backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom',
    },
    title: {
        fontSize: 18,
        fontWeight: 700,
        margin: theme.spacing(4, 0, 2),
    },
    headingTitle: {
        textAlign: 'center',
        fontSize: 25,
        fontWeight: 'bold',
    },
    searchtabsWrapper: {
        display: 'flex',
        justifyContent: 'center',
        '& .MuiTab-root' : {
            minWidth: 'auto',
            fontSize: 20,
            fontWeight: 500,
        },
    },
    tabLabelInner: {
        display: 'flex',
        textAlign: 'center',
        textTransform: 'capitalize',
        alignItems: 'center',
    },
    tabBadge: {
        fontSize: 15,
        fontWeight: 500,
        padding: 5,
        borderRadius: 5,
        lineHeight: 1,
        backgroundColor: 'rgba(216,216,216,1)',
        marginLeft: 5,
    },
    showAllWrapper: {
        textAlign: 'center',
        fontSize: 15,
        fontWeight: 500,
        margin: theme.spacing(2, 0, 7),
    },
    showAllLink: {
        backgroundColor: 'transparent',
        color: 'rgba(23, 132, 255, 1)',
        cursor: 'pointer',
    },
    adminSearchResultWrapper: {
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    noResultWrapper: {
        backgroundColor: '#ffffff',
        textAlign: 'center',
        padding: theme.spacing(5)
    },
    titleNoResult: {
        fontSize: 25,
        fontWeight: 'bold',
    },
    noResultImg: {
        marginBottom: theme.spacing(5),
    },
}));
